import React from 'react';

const SyncSection = ({ settings, onChange }) => {
  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <i className="bi bi-arrow-repeat" />
        Sync Configuration
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Default Page Size</span>
          <span className="settings-row-help">Number of records fetched per API page (100–2000)</span>
        </div>
        <div className="settings-row-control">
          <input
            type="number"
            className="settings-number-input"
            min={100}
            max={2000}
            step={100}
            value={settings['sync.defaultPageSize'] ?? 1000}
            onChange={e => onChange('sync.defaultPageSize', Math.min(2000, Math.max(100, Number(e.target.value))))}
          />
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Parallel Sync Mode</span>
          <span className="settings-row-help">Fetch multiple data types simultaneously for faster syncs</span>
        </div>
        <div className="settings-row-control">
          <button
            className={`settings-toggle${settings['sync.parallelMode'] ? ' active' : ''}`}
            onClick={() => onChange('sync.parallelMode', !settings['sync.parallelMode'])}
            aria-label="Toggle parallel sync mode"
          >
            <span className="settings-toggle-knob" />
          </button>
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Rate Limit Delay</span>
          <span className="settings-row-help">Delay in milliseconds between consecutive API calls</span>
        </div>
        <div className="settings-row-control">
          <input
            type="number"
            className="settings-number-input"
            min={0}
            max={5000}
            step={50}
            value={settings['sync.rateLimitDelay'] ?? 100}
            onChange={e => onChange('sync.rateLimitDelay', Math.max(0, Number(e.target.value)))}
          />
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Max Retries</span>
          <span className="settings-row-help">Number of retry attempts on API failure (1–10)</span>
        </div>
        <div className="settings-row-control">
          <input
            type="number"
            className="settings-number-input"
            min={1}
            max={10}
            value={settings['sync.maxRetries'] ?? 3}
            onChange={e => onChange('sync.maxRetries', Math.min(10, Math.max(1, Number(e.target.value))))}
          />
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Sync Timeout</span>
          <span className="settings-row-help">Maximum duration for a single sync operation (minutes)</span>
        </div>
        <div className="settings-row-control">
          <input
            type="number"
            className="settings-number-input"
            min={5}
            max={240}
            value={settings['sync.timeoutMinutes'] ?? 60}
            onChange={e => onChange('sync.timeoutMinutes', Math.min(240, Math.max(5, Number(e.target.value))))}
          />
        </div>
      </div>
    </div>
  );
};

export default SyncSection;
